import { environment } from '@coin/shared/core/util-environments';

export const CMS_TEXT_ARROW_RIGHT = `${environment.coinImagePath}coin/images/originals/9677bd45-8030-4a71-a26c-4d7d4f226145.gif`;
